import { render, staticRenderFns } from "./file_row_stats.vue?vue&type=template&id=12e615c3"
import script from "./file_row_stats.vue?vue&type=script&lang=js"
export * from "./file_row_stats.vue?vue&type=script&lang=js"
import style0 from "./file_row_stats.vue?vue&type=style&index=0&id=12e615c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports